export const ALLOWED_IMAGES_FORMAT = 'image/png, image/jpeg, image/svg';
export const BRANDING_TOKEN_TYPE = 'branding';
